export default __webpack_public_path__ + "static/media/27.3dd9a3f5.png";